var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["LitElement"]: () => __WEBPACK_EXTERNAL_MODULE_lit__.LitElement, ["css"]: () => __WEBPACK_EXTERNAL_MODULE_lit__.css, ["html"]: () => __WEBPACK_EXTERNAL_MODULE_lit__.html });